export const SET_ARTIKELTYPEN = "setArtikeltypen";
export const SET_ARTIKELEINHEITEN = "setArtikelEinheiten";
export const SET_ARTIKEL = "setArtikel";
export const SET_KONTO = "setKonto";
export const SET_KOSTENSTELLE = "setKostenStelle";
export const SET_MEHRWERTSTEUERCODE = "setMehrwertsteuerCode";
